import styled from '@emotion/styled'

const NavActionsContainer = styled.div`
    overflow: hidden;
    width: 100%;
    transition: max-height 0.5s ease-out;

    @media (max-width: ${props => props.theme.bps.md}) {
        display: none;
    }

    @media (min-width: ${props => props.theme.bps.md}) {
        overflow: visible;
        max-height: initial;
        padding: 1rem 0 0;
        column-gap: 0;
        grid-template-columns: 1fr auto;
        grid-template-rows: repeat(2, 1fr);
    }

    @media (min-width: ${props => props.theme.bps.lg}) {
        padding: 0;

        gap: 1rem;
        grid-template-columns: 1fr auto auto;
        grid-template-rows: 1fr;
    }
`

const getLinkShadowBox = theme => {
    const { primary } = theme.colors
    const colorWithAlpha = `${primary}CC` // 80%
    return `0 0 4px 2px ${colorWithAlpha}, inset 0 0 2px 0px ${colorWithAlpha}`
}

const Navigation = styled.div`
    padding: 1rem 0;
    text-transform: uppercase;
    justify-content: space-between;

    display: grid;
    grid-area: 2 / 1 / 3 / 2;
    ul {
        font-size: 1.125rem;
        font-weight: bold;
        display: grid;
    }

    @media (max-width: ${props => props.theme.bps.md}) {
        justify-content: space-between;
        ul {
            margin-left: 5rem;
            gap: 2rem;

            li {
                a {
                    color: ${({ theme }) => theme.colors.white};
                    font-weight: bold;
                    font-size: 1.5rem;

                    &.selected {
                        color: ${({ theme }) => theme.colors.border};
                    }
                }
            }
        }
    }

    @media (min-width: ${({ theme }) => theme.bps.md}) {
        padding: 2rem 0;
        border-top: none;
        border-bottom: none;
        text-transform: initial;

        display: flex;
        align-items: center;
        grid-area: 2 / 1 / 3 / 3;

        ul {
            display: flex;
            font-size: 1rem;
            margin-left: 4rem;

            background-color: rbga(rgb(#1d31b6), 0.5);

            li {
                padding: 0 1.2rem;
                position: relative;

                a {
                    display: inline-block;
                    padding: 0.15rem 0.5rem;
                    font-weight: bold;
                    font-size: 1.125rem;
                    color: white !important;

                    // Force hardware acceleration to prevent flickering:
                    transform: translate3d(0, 0, 0);
                    -webkit-transform: translate3d(0, 0, 0);

                    transition: transform 0.25s ease-out;
                    border-bottom: transparent 3px solid;
                }

                &:hover {
                    a {
                        transform: scale(1.1);
                        border-bottom: ${({ theme }) => theme.colors.primary} 3px solid;
                    }
                }

                .selected {
                    color: ${({ theme }) => theme.colors.primary};
                }
            }
        }
    }

    @media (min-width: ${props => props.theme.bps.lg}) {
        padding: 0 2rem;
        align-items: center;
        grid-area: initial;
        justify-content: space-between;
    }
    @media (min-width: ${props => props.theme.bps.lg}) {
        height: 5vh;
    }
`

export { Navigation, NavActionsContainer }
